import { Stack, styled } from '@mui/material';

export const TournamentPageLayout = styled(Stack)(() => ({
  backgroundColor: 'black',
  backgroundBlendMode: 'overlay',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  height: '100vh',
}));
